import { render, staticRenderFns } from "./PendencyModal.vue?vue&type=template&id=3d5c2a10&scoped=true"
import script from "./PendencyModal.vue?vue&type=script&lang=js"
export * from "./PendencyModal.vue?vue&type=script&lang=js"
import style0 from "./PendencyModal.vue?vue&type=style&index=0&id=3d5c2a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c2a10",
  null
  
)

export default component.exports